// Cálculos del cobro desde el celular. Mismas reglas que la PC: la propina
// sugerida es el 10 % del consumo y, con dos medios de pago, el segundo
// monto se completa solo con lo que falta.

export const redondear2 = (valor) => Number(Number(valor || 0).toFixed(2));

export const money = (valor) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(valor || 0));

export const resumenCobro = ({
  consumo = 0,
  pagado = 0,
  propinaPersistida = 0,
  propinaEditable = true,
  conPropina = false,
}) => {
  const consumoTotal = redondear2(consumo);
  const propina = propinaEditable
    ? conPropina
      ? redondear2(consumoTotal * 0.1)
      : 0
    : redondear2(propinaPersistida);
  const total = redondear2(consumoTotal + propina);
  const saldo = redondear2(Math.max(0, total - redondear2(pagado)));

  return { consumo: consumoTotal, propina, total, saldo };
};

// Monto que le toca al otro medio cuando se divide el pago.
export const complemento = (valor, saldo) => {
  const numero = redondear2(valor);

  return numero > 0 && numero < saldo ? String(redondear2(saldo - numero)) : '';
};

// Valida los pagos tipeados y los deja listos para enviar al servidor.
export const normalizarPagos = (pagos, saldo) => {
  if (!Array.isArray(pagos) || pagos.length < 1) {
    return { error: 'Elegí un medio de pago.' };
  }

  const normalizados = pagos.map((pago) => ({
    medio_pago_id: Number(pago.medio_pago_id),
    monto: redondear2(pago.monto),
  }));

  const invalido = normalizados.some(
    (pago) =>
      !Number.isInteger(pago.medio_pago_id) ||
      pago.medio_pago_id < 1 ||
      !Number.isFinite(pago.monto) ||
      pago.monto <= 0
  );

  if (invalido) {
    return { error: 'Completá el medio y el monto de cada pago.' };
  }

  const ingresado = redondear2(
    normalizados.reduce((suma, pago) => suma + pago.monto, 0)
  );

  if (ingresado > saldo + 0.01) {
    return { error: 'Los pagos superan el saldo de la cuenta.' };
  }

  return { pagos: normalizados, ingresado };
};

// Clave para que un cobro o un pedido reenviado por mala señal no se duplique.
export const claveNueva = () =>
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
